/**
 * House関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const ReservationSegmentState = Record({
  segment_category_id: null,
  segment_value_id: null
})

export { ReservationSegmentState }
